/* BELORA - TEK YETKILI SEPETE EKLEME DENETLEYICISI
   ---------------------------------------------------------------------------
   ⚠️ Bu dosya eskiden `ws-bundle.js` idi ve IKI is yapiyordu: PDP ek-urun
   (companion/set) UI'i + atomik ekleme. Sahip karari (2026-09-04) ile ozel
   PDP set/upsell modulu KALDIRILDI; geriye ATC guvenilirlik motoru kaldi ve
   dosya adi isine uyacak sekilde degistirildi. Companion metafield VERISI
   Shopify'da SILINMEDI - ileride baska bir yuzeyde kullanilabilir.

   KOK NEDENLER (olculdu 2026-09-01, taslak temada enstrumante kosum):

   1) GORUNMEZ BEKLEME. Prestige yalnizca `aria-busy` yazar; bu temanin
      ATC dugmesi `.ws-btn` sinifindadir ve `[aria-busy]` gorsel kurali
      eski BELORA katmanindaki `.button` sinifini hedefliyordu (olu
      secici). Musteri dokunuyor, 875ms boyunca HICBIR sey degismiyor.

   2) SESSIZ BASARILI EKLEME. Prestige'in `onSubmit_fn` fonksiyonunda
      `try/catch` YOK. `/cart/add.js` BASARIYLA donduktan sonra gelen
      `cart.js` istegi veya JSON ayristirmasi patlarsa (yavas ag, bot
      dogrulamasi, HTML donen yanit) `cart:change` HIC atilmaz: urun
      sepete GIRER ama cekmece acilmaz ve hata da gosterilmez. Musteri
      "olmadi" sanip TEKRAR basar -> IKI adet.

   3) KILIT COK ERKEN BIRAKILIR. `aria-busy` add yanitinin hemen ardindan
      silinir; oysa cekmece daha sonra acilir. Aradaki pencerede ikinci
      tiklama GERCEK ikinci mutasyon baslatir.

   4) KILIT `event.submitter`e BAGLI. `requestSubmit()` gibi yollarda
      submitter null olur ve koruma tamamen devre disi kalir.

   COZUM: gonderim TEK bir yerden yonetilir (capture + immediate stop),
   tek-ucus kilidi ISTEK YASAM DONGUSUNE baglidir (keyfi zaman asimi YOK),
   belirsiz sonuc sepetin GERCEK durumuyla uzlastirilir ve cekmece render'i
   basarisiz olursa mutasyon TEKRARLANMAZ - yalniz yeniden render edilir.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var flight = null;                      /* tek-ucus: aktif islem sozu */

  function atcBtn(form) { return form.querySelector('[data-ws-atc]'); }
  function msgBox(form) { return form.querySelector('[data-ws-atc-msg]'); }

  function label(btn, key, fallback) {
    return (btn && btn.getAttribute('data-label-' + key)) || fallback;
  }

  function paint(form, state, text) {
    var btn = atcBtn(form);
    var msg = msgBox(form);
    if (!btn) return;
    var stateLabel = btn.querySelector('[data-ws-atc-state-label]');
    if (state === 'idle') {
      btn.removeAttribute('data-ws-state');
      btn.removeAttribute('aria-busy');
      if (btn.__wsPrevDisabled === false) btn.disabled = false;
      delete btn.__wsPrevDisabled;
    } else {
      if (btn.__wsPrevDisabled === undefined) btn.__wsPrevDisabled = btn.disabled;
      btn.setAttribute('data-ws-state', state);
      if (state === 'pending') {
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
      } else {
        btn.removeAttribute('aria-busy');
        btn.disabled = state === 'success' ? true : false;
      }
      if (stateLabel) {
        stateLabel.textContent = state === 'pending'
          ? label(btn, 'pending', 'Ekleniyor...')
          : label(btn, 'success', 'Eklendi');
      }
    }
    if (msg) {
      if (text) { msg.textContent = text; msg.hidden = false; }
      else { msg.textContent = ''; msg.hidden = true; }
    }
  }

  var sleep = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  /* Sepetin GERCEK hali. Basarisiz olursa null doner - "bilmiyorum" demektir,
     "bos" demek DEGILDIR. */
  async function serverCart() {
    try {
      var r = await fetch(ROOT + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!r.ok) return null;
      /* ⚠️ CONTENT-TYPE ILE KARAR VERME. Shopify `/cart.js` yanitini
         `text/javascript` olarak dondurur; "json" araman gecerli sepeti
         REDDEDER ve uzlastirma sessizce devre disi kalir. Govdenin
         gercekten bir sepet nesnesi olup olmadigina bakilir - boylece
         bot dogrulama/HTML sayfalari da guvenle elenir. */
      var txt = await r.text();
      if (!txt || txt.charAt(0) !== '{') return null;
      var j = JSON.parse(txt);
      return (j && Array.isArray(j.items)) ? j : null;
    } catch (e) { return null; }
  }

  /* ⚠️ ONCEKI DURUM ICIN EK ISTEK ATMA.
     Uzlastirmanin `before` anlik goruntusu, cekmecenin ZATEN sunucudan
     render edilmis satirlarindan okunur - boylece her eklemede fazladan
     bir `/cart.js` cagrisi (ve ek gecikme) olusmaz. `data-line-key`
     "<varyantId>:<ozellik-hash>" bicimindedir. Cekmece hic render
     edilmemisse null doner ("bilmiyorum"), BOS sepet ise {} doner. */
  function domCartMap() {
    var d = document.querySelector('cart-drawer');
    if (!d) return null;
    var nodes = d.querySelectorAll('[data-line-key]');
    if (!nodes.length) return d.querySelector('.ws-cart__item') ? null : {};
    var m = {};
    for (var i = 0; i < nodes.length; i++) {
      var key = nodes[i].getAttribute('data-line-key') || '';
      var vid = key.split(':')[0];
      var raw = nodes[i].value != null ? nodes[i].value : nodes[i].getAttribute('value');
      var q = parseInt(raw, 10);
      if (vid && q > 0) m[vid] = (m[vid] || 0) + q;
    }
    return m;
  }

  function qtyMap(cart) {
    var m = {};
    if (!cart || !cart.items) return m;
    cart.items.forEach(function (i) { m[String(i.variant_id)] = (m[String(i.variant_id)] || 0) + i.quantity; });
    return m;
  }

  /* Beklenen artis GERCEKTEN uygulanmis mi? */
  function applied(before, after, items) {
    if (!after) return null;                              /* bilinmiyor */
    for (var k = 0; k < items.length; k++) {
      var id = String(items[k].id);
      var was = before[id] || 0;
      var now = after[id] || 0;
      if (now < was + items[k].quantity) return false;
    }
    return true;
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.show === 'function') { try { d.show(); } catch (e) {} }
  }

  /* Cekmeceyi tazele. Mutasyon ASLA tekrarlanmaz. */
  function publish(cart, sections) {
    var ok = !!(cart && sections);
    if (ok) {
      cart.sections = sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'open_drawer', cart: cart }
      }));
    } else {
      /* Bolum yaniti yok/gecersiz: SADECE yeniden render (mutasyon TEKRAR YOK).
         ⚠️ Cekmece ancak GERCEKTEN icerik geldiyse acilir. Olculdu: bolum
         yaniti 429 dondugunde cekmece ESKI (bos) icerigiyle aciliyor ve
         urun sepette oldugu halde musteri "sepetim bos" goruyordu. */
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(function () {
        var d = document.querySelector('cart-drawer');
        if (d && d.querySelector('.ws-cart__item')) openDrawer();
      }, 700);
    }
  }

  async function runAdd(form, items) {
    var btn = atcBtn(form);
    paint(form, 'pending', '');

    /* Sifir ek istek: once cekmece DOM'u, olmazsa sunucuya sor. */
    var before = domCartMap();
    if (before === null) { var bc = await serverCart(); before = bc ? qtyMap(bc) : null; }
    var beforeKnown = before !== null;                  /* null = "bilmiyorum" (bos DEGIL) */
    if (!beforeKnown) before = {};
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections: sections }
    }));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var payload = null, httpOk = false, ambiguous = false;
    try {
      var res = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections.join(',') })
      });
      httpOk = res.ok;
      try { payload = await res.json(); } catch (e) { payload = null; ambiguous = httpOk; }
      if (!httpOk && !payload) ambiguous = true;          /* neden reddedildigi bilinmiyor */
    } catch (e) {
      ambiguous = true;                                   /* ag koptu: Shopify KABUL ETMIS OLABILIR */
    }
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    /* ---- BELIRSIZ SONUC: kor tekrar YOK, once GERCEK sepete bak ---- */
    var success = httpOk && !!payload;
    var unresolved = false;
    if (ambiguous || !httpOk) {
      /* ⚠️ Uzlastirma yalniz ONCEKI durum BILINIYORSA gecerlidir.
         `before` alinamadiysa "sonra >= once + n" kiyasi, urun sepette
         ZATEN varken YANLIS "eklendi" verdikleri uretir. O durumda
         basari IDDIA EDILMEZ; sepetin gercegi gosterilir. */
      var after = beforeKnown ? qtyMap(await serverCart()) : null;
      var verdict = beforeKnown ? applied(before, after, items) : null;
      if (verdict === true) success = true;               /* aslinda eklenmis */
      else if (verdict === false) success = false;        /* gercekten eklenmemis */
      else { success = false; unresolved = true; }        /* bilinmiyor -> iddia etme */
    }

    if (!success) {
      var reason = (payload && payload.description) ? payload.description : '';
      form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: reason || 'add failed' } }));
      if (unresolved) {
        /* Ne "eklendi" ne "eklenmedi" denebilir: musteriye SEPETIN GERCEGI
           gosterilir, boylece kor bir ikinci ekleme yapmaz. */
        paint(form, 'error', label(btn, 'unresolved', 'Baglanti kesildi. Sepetinizi kontrol edin.'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(openDrawer, 500);
      } else {
        paint(form, 'error', label(btn, 'error', 'Sepete eklenemedi. Tekrar deneyin.'));
      }
      setTimeout(function () { paint(form, 'idle', ''); }, 4000);
      return;
    }

    /* ---- BASARILI ---- */
    paint(form, 'success', '');
    var cart = await serverCart();
    form.dispatchEvent(new CustomEvent('variant:add', {
      bubbles: true,
      detail: { items: (payload && payload.items) ? payload.items : (payload ? [payload] : []), cart: cart, onSuccessDo: 'open_drawer' }
    }));

    await sleep(420);                                     /* "✓ EKLENDI" gorunur kalsin */
    publish(cart, payload && payload.sections);
    await sleep(700);
    paint(form, 'idle', '');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    /* SAHIPLIK BIZDE - temanin kendi gonderimi HIC calismaz.
       Boylece "yerel form + ozel JS" ikili gonderimi imkansizdir. */
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (flight) return;                                   /* islem surerken ek dokunuslar YUTULUR */

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var mainId = form.id && form.id.value ? String(form.id.value).trim() : '';
    if (!mainId) {                                        /* ana varyant secilmemis */
      paint(form, 'error', label(atcBtn(form), 'size', 'Beden secin'));
      setTimeout(function () { paint(form, 'idle', ''); }, 2500);
      return;
    }

    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput && Number(qtyInput.value) > 0 ? Number(qtyInput.value) : 1;

    var items = [{ id: Number(mainId), quantity: qty }];

    /* Kilit ISTEK YASAM DONGUSUNE bagli - keyfi zaman asimi YOK. */
    flight = runAdd(form, items).catch(function () {
      paint(form, 'error', label(atcBtn(form), 'error', 'Sepete eklenemedi. Tekrar deneyin.'));
      setTimeout(function () { paint(form, 'idle', ''); }, 4000);
    }).then(function () { flight = null; });
  }, true);   /* CAPTURE: Prestige'in form dinleyicisinden ONCE calisir */
})();
